import { Box, styled } from "@mui/material";

export const Section = styled(Box)(({ theme }) => (props) => ({
  display: "flex",
  gap: "12px",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));
export const Image = styled("img")(({ theme }) => (props) => ({
  width: "144px",
  height: "144px",
}));

export const ImageList = styled("div")(({ theme }) => (props) => ({
  maxWidth: "60vw",
  display: "flex",
  gap: "24px",
  justifyContent: "center",
  alignItems: "center",
  maxHeight: "150px",
  margin: "12px 0",
  overflowX: "none",
  overflowY: "auto",
  [theme.breakpoints.down("sm")]: {
    maxWidth: "90vw",
  },
}));
export const CompImage = styled(Box)(({ theme }) => (props) => ({
  width: "144px",
  height: "144px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  border: "1px solid",
  borderColor:
    theme.palette.mode === "light"
      ? theme.palette.text.light
      : theme.palette.text.dark,
  margin: "12px 0",
}));
